import {createStore} from "vuex";
import {store as filter, FilterStore, State as FilterState} from "./modules/filter/index";
import {store as product, ProductStore, State as ProductState} from "./modules/product/index";
import {store as translation, TranslationStore} from "./modules/translation/index";
import {TransitionState} from "vue";

export type RootState = {
    filter: FilterState;
    product: ProductState;
    translation: TransitionState;
};

export type Store = FilterStore<Pick<RootState, 'filter'>>
    & ProductStore<Pick<RootState, 'product'>>
    & TranslationStore<Pick<RootState, 'translation'>>;

export const store = createStore({
    modules: {
        filter,
        product,
        translation,
    },
});

export function useStore(): Store {
    return store as Store;
}